var exports = {
  "kL": "xae11d333--66ad00--container",
  "YB": "xae11d333--66ad00--columns",
  "R5": "xae11d333--66ad00--column-regions",
  "Ny": "xae11d333--66ad00--region",
  "Ri": "xae11d333--66ad00--clickable-text",
};

module.exports = exports;
